import { BulkPaymentLinkDeliveryMethod } from 'types';

import { api } from './api';

export interface CreateBulkPaymentLinksRequest {
  accountIds: string[];
  deliveryMethod: BulkPaymentLinkDeliveryMethod;
  expirationHours?: number;
}

export interface CreateBulkPaymentLinksResponse {
  jobId: string;
  total: number;
  status: string;
}

export interface BulkPaymentLinkJobSummary {
  jobId: string;
  requestedByEmail: string | null;
  requestedAt: string | null;
  completedAt: string | null;
  deliveryMethod: BulkPaymentLinkDeliveryMethod;
  status: string;
  total: number;
  duplicates: number | null;
  succeeded: number | null;
  failed: number | null;
}

export const bulkPaymentLinksApi = api.injectEndpoints({
  endpoints: (build) => ({
    createBulkPaymentLinks: build.mutation<CreateBulkPaymentLinksResponse, CreateBulkPaymentLinksRequest>({
      query: (body) => ({
        url: '/admin/bulk-payment-links',
        method: 'POST',
        body,
      }),
    }),
    getBulkPaymentLinkJobs: build.query<{ jobs: BulkPaymentLinkJobSummary[] }, void>({
      query: () => ({
        url: '/admin/bulk-payment-links',
        method: 'GET',
      }),
    }),
  }),
});

export const { useCreateBulkPaymentLinksMutation, useGetBulkPaymentLinkJobsQuery } = bulkPaymentLinksApi;
